import angular, { ILogService, IOnChangesObject } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import {
  ICVHistoricoBusqueda,
  IEstadoCvStore,
  IModelAccion,
  IModelEstadoCv,
  IReporteCVHistorico
} from 'src/model/candidato-api'

class PanelCvHistoricComponentCtrl {
  cvhist!: ICVHistoricoBusqueda
  tipos!: TiposDocEstadosStore

  report: IReporteCVHistorico

  $loading = false

  history = {
    add: {
      active: false,
      text: '',
      state: null as IModelEstadoCv,
    },
    list: [] as IModelAccion[],
  }
  statesStore: IEstadoCvStore

  constructor(
    private $log: ILogService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelCvHistoricComponentCtrl] onInit')
  }

  $onChanges(obj: IOnChangesObject) {
    if (obj && obj.cvhist) {
      this.report = null
      this.history.add.active = false
      this.history.add.state = null
      this.history.add.text = ''

      if (obj.cvhist.currentValue) this._leerCV()
    }

    if (obj.tipos && obj.tipos.currentValue) {
      this.$log.info('----> tipos!!!')

      this.statesStore = this.tipos.estadosStore()
    }
  }

  private _leerCV() {
    this.$loading = true
    this.AccesoDatos.HistoricCurr_CLIENT.datosCvHistorico(this.cvhist.curr.idcvhist).then((reportResponse) => {
      this.report = reportResponse
      this.history.list = reportResponse.history.list

      this.$loading = false
    })
  }

  _refreshcv() {
    this.report = null

    this._leerCV()
  }
}

angular.module('candidato').component('panelCvHistoric', {
  bindings: {
    cvhist: '<',
    tipos: '<',
  },
  controller: PanelCvHistoricComponentCtrl,
  // templateUrl: "panel-cv-historic.component.html",
  template: require('./panel-cv-historic.component.html'),
})
